import { MapSettings, StoredMapSettings } from "../types/types";

/** Labels the light calculator needs regardless of the user's own label settings. */
export const LIGHT_CALCULATOR_LABELS = ["karakter", "periode"] as const;

/**
 * Fills in defaults for map settings written before `labelsEnabled` existed. Settings that
 * already had labels saved were, by definition, showing them - so they migrate to enabled.
 */
export const normalizeMapSettings = (mapSettings: StoredMapSettings | null): MapSettings | null => {
    if (!mapSettings) return null;

    const enabledLabels = mapSettings.enabledLabels ?? [];

    return {
        ...mapSettings,
        enabledLabels,
        labelsEnabled: mapSettings.labelsEnabled ?? enabledLabels.length > 0,
    };
};

/**
 * The labels that should be on the NFS layers right now. The user's selection is kept even
 * while labels are toggled off, so it can be switched back on without reconfiguring it.
 */
export const resolveLabelsToApply = (
    mapSettings: StoredMapSettings | null,
    { lightCalcOpen }: { lightCalcOpen: boolean }
): string[] => {
    const settings = normalizeMapSettings(mapSettings);
    const labels = settings?.labelsEnabled ? [...settings.enabledLabels] : [];

    if (lightCalcOpen) {
        for (const label of LIGHT_CALCULATOR_LABELS) {
            if (!labels.includes(label)) {
                labels.push(label);
            }
        }
    }

    return labels;
};
